import React from 'react';
import LogoIcon from '../../atoms/static-icons/cattolica-logo';
import { Link } from '../link';

const LogoFooter = ({ disableLinkLogo }) => {
  return (
    <div className='footer__top-bar--wrapper-logo'>
      {!disableLinkLogo && (
        <Link to='/' title='Cattolica Assicurazioni'>
          <LogoIcon className='footer__top-bar--logo' />
        </Link>
      )}
      {disableLinkLogo && <LogoIcon className='footer__top-bar--logo' />}
    </div>
  );
};

export default LogoFooter;
